import { env, type AppEnv } from '@/config/env';
import type { AuthAdapter } from '../types';

/** Creates the adapter selected by VITE_AUTH_PROVIDER (loaded lazily). */
export async function createAuthAdapter(config: AppEnv = env): Promise<AuthAdapter> {
  if (config.authProvider === 'mock') {
    const { createMockAdapter } = await import('./mock');
    return createMockAdapter();
  }
  const { createBackendAdapter } = await import('./backend');
  return createBackendAdapter({ apiUrl: config.apiUrl });
}
